var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { useQueries } from "@tanstack/react-query";
import { accountSummaryV2CacheKey } from "../cacheKeys.js";
import queryFnFactory from "./query.js";
function useAllAccountSummaryQuery({
  config,
  keyProps,
  queryOptions = {}
}) {
  return useQueries(__spreadValues({
    queries: keyProps == null ? void 0 : keyProps.map((accountKeyProps) => {
      const { accountId, accountIdType } = accountKeyProps;
      return {
        queryKey: accountSummaryV2CacheKey({ accountId, accountIdType }),
        queryFn: queryFnFactory(config, accountKeyProps),
        select: (accountSummaryData) => {
          return __spreadValues({ accountId }, accountSummaryData);
        }
      };
    })
  }, queryOptions));
}
export {
  useAllAccountSummaryQuery
};
//# sourceMappingURL=allAccountSummaryQuery.js.map
